import DailyMenuOptionOffer from '@/model/dailymenu/DailyMenuOptionOffer'

export default class DailyMenuOption {
  private constructor (
    readonly id: string,
    readonly name: string,
    readonly code: string,
    readonly offer: DailyMenuOptionOffer | undefined,
    readonly referencePrice: number | null

  ) {}

  static createSingleFromResponse(responseData: any): DailyMenuOption {
    return new DailyMenuOption(
      responseData.id,
      responseData.name,
      responseData.code,
      undefined,
      parseFloat(responseData.referencePrice)
    )
  }

  static createFromResponse (responseData: any[]): DailyMenuOption[] {

    return responseData.map( (value:any):DailyMenuOption =>new DailyMenuOption(
        value.id,
        value.name,
        value.code,
        DailyMenuOptionOffer.createFromResponse(value.offer),
        parseFloat(value.referencePrice)
    ))

  }
}
